import { render, staticRenderFns } from "./acoes-por-modulo.vue?vue&type=template&id=6a013158&scoped=true&"
import script from "./acoes-por-modulo.vue?vue&type=script&lang=js&"
export * from "./acoes-por-modulo.vue?vue&type=script&lang=js&"
import style0 from "./acoes-por-modulo.vue?vue&type=style&index=0&id=6a013158&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a013158",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a013158')) {
      api.createRecord('6a013158', component.options)
    } else {
      api.reload('6a013158', component.options)
    }
    module.hot.accept("./acoes-por-modulo.vue?vue&type=template&id=6a013158&scoped=true&", function () {
      api.rerender('6a013158', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/acoes-por-modulo/acoes-por-modulo.vue"
export default component.exports